module.exports = __webpack_public_path__ + "static/media/fontein_in_spanje.a1f167d5.jpg";